import { Outlet } from "react-router-dom";
import ProfileNav from "../components/ProfileNav";

export default function ProfileLayout() {
  return (
    <div className="flex flex-col gap-4 text-white">
      <div className="flex flex-col gap-4 lg:flex-row">
        <aside className="lg:w-72 xl:w-80 flex-shrink-0">
          <ProfileNav />
        </aside>
        <main className="flex-1 border-l -mt-6 border-sidebar-active min-h-[calc(100vh-48px)]">
          <div className="rounded-xl bg-main-dark p-6 pr-0">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
